


































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetData } from "@/request/tem";
@Component({})
export default class Name extends Vue {
  @Prop()
  private nav: any;
  @Watch("nav", { immediate: true })
  private navChange() {
    if (this.nav) {
      this.data = JSON.parse(JSON.stringify(this.nav));
    }
  }
  private ifShowMoban: any = false;
  private data: any = [];
  private currentNav: any = {};
  private api: any = {};
  private templates: any = [];
  private clickNav(item: any, level: any, api: any) {
    if (item.children) {
      //点击父结构
      item.open = !item.open;
    } else {
      this.currentNav = item;
      this.getTemplates(api);
    }
    if (level == 2 && item.children) {
      // 获取三级选项
      this.$store.commit("updateToken", item.token);
      this.$store.commit("updateAPIROOT", item.API_ROOT);
      if (api) {
        const params: any = {};
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        GetData(this, api["三级nav"][0], api["三级nav"][1], params, loading)
          .then((res: any) => {
            loading.close();
            res.forEach((ele: any) => {
              res.parent = item;
            });
            item.children = res;
          })
          .catch(() => {
            loading.close();
          });
      } else {
      }
    }
  }
  private getTemplates(api: any) {
    this.api = api;
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        patient_id: "9be103390929",
        project_id: this.currentNav.project_id,
        group_id: this.currentNav.group_id,
        zhenci_id: "642152e89e752a0036a4a98d",
        type: "诊次",
      },
    };
    GetData(this, api["量表列表"][0], api["量表列表"][1], params, loading)
      .then((res: any) => {
        loading.close();
        this.templates = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private selectTem(item: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        patient_id: "9be103390929",
        project_id: this.currentNav.project_id,
        group_id: this.currentNav.group_id,
        zhenci_id: "642152e89e752a0036a4a98d",
        template_id: item.template_id,
      },
    };
    GetData(
      this,
      this.api["量表内容"][0],
      this.api["量表内容"][1],
      params,
      loading
    )
      .then((res: any) => {
        loading.close();
        this.$emit("import", res.data);
      })
      .catch(() => {
        loading.close();
      });
  }
}
